import {
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Copy,
  Delete,
  Search,
  Send,
  Slash,
  ThumbsUp
} from 'react-feather'
import { X } from 'react-feather'
import styled from 'styled-components'

export const CloseIcon = styled(X)<{ onClick: () => void }>`
  cursor: pointer;
`

export {
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CheckCircle,
  Copy,
  Delete,
  Search,
  Slash,
  Send,
  ThumbsUp
}
